export const DEFAULT_BASE_URL = 'https://exchange.exodus.io/v3';
export const ALLOWED_SOURCES = ['exodus', 'jupiter', 'lifi', 'rango'];
